var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamelevel2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 87,
    viewBox: "0 0 160 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.817479 66.8019V66.8071C3.05888 73.8224 10.1436 80.2503 24.5792 82.7481C62.0405 89.2303 76.0169 85.9866 81.7532 78.0135L81.7584 78.0089C83.9174 75.0072 92.4878 75.9552 103.116 77.6634H103.12C103.139 77.6654 103.157 77.6687 103.175 77.6732C103.258 77.6876 103.338 77.6974 103.422 77.7125C121.002 80.5564 144.028 85.3893 152.851 77.8806C156.39 74.864 158.523 69.354 159.066 62.6841C159.26 60.2441 159.256 57.7923 159.056 55.3528V55.3482C157.551 36.2721 144.859 12.5399 117.926 8.11267C79.4725 1.79344 66.0457 12.2108 50.0825 28.1472C34.1192 44.0837 34.2939 41.1462 16.7434 42.242C11.6404 42.558 7.00782 45.5642 3.91723 49.8252C0.46223 54.5782 -1.07325 60.8974 0.817479 66.8019Z",
    fill: "url(#paint0_linear_2_12365)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5793 82.7478C62.0505 89.2299 76.0216 85.9862 81.7592 78.0085C87.4968 70.0308 138.633 89.9809 152.851 77.8777C157.627 73.8142 159.837 65.2045 159.057 55.3498C159.037 55.7797 157.945 75.2313 139.852 77.9071C121.561 80.6123 96.3793 71.9281 87.0336 73.9817C76.8067 76.2264 75.8351 84.1786 50.9279 83.5865C26.0206 82.9944 8.39624 75.8947 2.90724 68.9487C-2.58177 62.0027 3.91933 49.8229 3.91933 49.8229C-3.64555 60.2304 -2.00605 78.1465 24.5793 82.7478Z",
    fill: "url(#paint1_linear_2_12365)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.879 55.2793C150.809 69.0182 109.665 70.6099 91.3305 65.1582C72.9963 59.7065 72.0614 63.0261 75.6158 67.259C79.1703 71.4918 56.6346 79.3394 30.7047 71.2001C4.77491 63.0607 9.4566 47.3127 28.4084 44.614C45.1888 42.2248 44.7923 43.789 51.7363 43.1152C58.6804 42.4413 59.5001 37.2199 51.7311 36.7632C42.1106 36.1973 69.0683 5.26392 107.981 10.2217C146.894 15.1795 156.374 44.1194 153.879 55.2793Z",
    fill: "url(#paint2_linear_2_12365)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.222 41.0093C152.222 41.0093 157.688 54.4008 143.595 61.3853C129.501 68.3699 111.977 68.7441 95.1401 64.7219C78.3028 60.6997 75.4962 60.1384 72.7837 61.1675C70.0713 62.1966 76.7457 68.2986 66.6411 71.488C56.5365 74.6774 31.0947 71.7372 21.3683 66.3745C11.6418 61.0118 12.8279 55.5908 12.8279 55.5908C12.8279 55.5908 8.33531 65.1786 33.3106 72.8076C58.2859 80.4366 72.9257 73.5613 76.0123 70.9888C79.099 68.4164 74.1419 64.4877 77.2286 63.6928C80.3152 62.8979 103.467 71.1759 127.414 69.3055C151.361 67.435 154.26 61.0739 155.29 54.8064C156.319 48.5388 152.222 41.0093 152.222 41.0093Z",
    fill: "url(#paint3_linear_2_12365)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5091 41.302C56.5091 41.302 57.6919 39.0285 55.5094 38.1244C53.3269 37.2202 51.7986 37.8751 50.271 37.4047C48.7434 36.9343 49.5075 33.9183 50.3174 32.9213C50.3174 32.9213 49.5539 35.0037 51.2687 35.565C52.9834 36.1263 55.7482 35.7796 56.8192 37.2156C57.2788 37.8158 57.5013 38.5642 57.4441 39.318C57.3869 40.0718 57.054 40.7781 56.5091 41.302Z",
    fill: "url(#paint4_linear_2_12365)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3867 57.2824C71.2699 60.2618 76.2447 70.8656 51.5494 71.1155C26.8541 71.3654 14.2581 57.4074 14.7567 52.7872C15.2552 48.167 46.1866 34.3418 68.3867 57.2824Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.586 50.2869C153.081 60.716 126.009 66.2855 93.456 59.6574C60.9034 53.0294 55.1037 42.5251 77.3672 37.1133C99.6307 31.7014 60.9015 35.8512 54.0209 33.4495C47.1403 31.0479 68.5547 8.55602 106.43 11.748C144.306 14.94 156.067 42.6814 147.586 50.2869Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7176 69.684C84.7972 60.5712 55.0558 48.6367 33.2222 53.7639C11.3885 58.8911 33.5323 77.0009 62.7176 69.684Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5323 82.401C50.4266 81.4654 29.0993 75.8528 17.5004 66.1243C5.90154 56.3959 14.1324 49.306 16.2842 47.3322C18.436 45.3583 1.74782 43.8595 1.30229 61.7253C0.856761 79.591 43.5323 82.401 43.5323 82.401Z",
    fill: "#FFDD81"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.494 71.1162C147.897 72.3919 147.427 78.3978 131.62 78.4351C115.813 78.4724 102.238 72.4652 89.428 73.6912C76.6181 74.9172 73.6355 82.1871 64.1818 82.8989C54.7282 83.6107 44.1211 78.753 43.5323 78.2852C42.9435 77.8175 64.0837 76.6948 71.5675 74.263C79.0512 71.8312 73.2508 65.37 78.2086 64.2978C83.1663 63.2255 105.729 71.0762 132.132 68.8473C158.536 66.6183 146.494 71.1162 146.494 71.1162Z",
    fill: "#FFDD81"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.857 76.2984C129.75 74.3566 111.23 67.6553 95.8879 68.0125C80.5455 68.3697 99.757 77.4917 123.857 76.2984Z",
    fill: "#FFDD81"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.817383 66.8068C3.05878 73.8221 10.1435 80.2499 24.5791 82.7478C62.0404 89.2299 76.0168 85.9862 81.7531 78.0131C81.4718 78.1963 71.7361 84.4507 43.5217 83.7108C14.8827 82.9604 0.817383 66.8068 0.817383 66.8068Z",
    fill: "url(#paint5_linear_2_12365)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.175 77.6731C120.785 80.5118 143.988 85.4238 152.851 77.8805C156.39 74.8638 158.523 69.3539 159.066 62.684C159.066 62.684 155.136 75.5004 138.637 78.0977C122.681 80.6106 104.36 77.8556 103.175 77.6731Z",
    fill: "url(#paint6_linear_2_12365)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.371 46.6683C39.5021 47.3984 29.0913 55.9276 20.9592 55.4611C12.8271 54.9947 16.8454 45.0778 32.371 46.6683Z",
    fill: "url(#paint7_linear_2_12365)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.65 13.3673C111.258 14.0614 92.4583 32.5265 65.8925 32.9243C39.3268 33.322 69.7898 12.664 90.65 13.3673Z",
    fill: "url(#paint8_linear_2_12365)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.739 15.4536C128.074 19.3659 110.259 20.4964 103.778 17.3273C97.2983 14.1582 109.919 9.6826 120.739 15.4536Z",
    fill: "url(#paint9_linear_2_12365)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3339 49.4718C35.0863 47.182 29.136 46.0044 22.4112 48.6324C15.6863 51.2605 17.2813 53.9069 17.2813 53.9069C17.2813 53.9069 18.0664 56.5107 25.8034 54.8404C33.5403 53.1702 34.3339 49.4718 34.3339 49.4718Z",
    fill: "#FFC74B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.3325 18.6829C99.3325 18.6829 98.5533 10.3741 77.3673 16.3276C56.1813 22.2811 56.6576 31.0086 56.6576 31.0086C56.6576 31.0086 60.8892 36.3667 79.6048 31.1329C98.3204 25.899 99.3325 18.6829 99.3325 18.6829Z",
    fill: "#9BB900"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.799 18.0437C121.799 18.0437 122.298 15.082 113.256 13.5858C104.214 12.0895 101.928 15.6087 102.106 15.9142C102.285 16.2197 102.434 18.3185 110.793 19.1638C119.152 20.009 121.799 18.0437 121.799 18.0437Z",
    fill: "#9BB900"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2171 78.8933C27.2125 78.5812 28.1088 75.9002 23.085 73.3742C18.0611 70.8482 15.5515 74.2044 15.2086 75.2453C14.8658 76.2862 19.8386 79.7353 25.2171 78.8933Z",
    fill: "#EDE0A9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5246 74.3094C27.5246 75.1835 26.5269 75.5256 25.6541 74.3094C24.7814 73.0932 27.5246 73.5302 27.5246 74.3094Z",
    fill: "#EDE0A9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7652 71.1225C13.0452 69.9521 11.4515 66.7392 7.98996 66.8046C4.52841 66.87 4.99684 69.1781 5.40247 69.8952C5.80809 70.6122 8.92551 72.0679 10.7652 71.1225Z",
    fill: "#EDE0A9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2242 79.5921C27.4414 77.9866 26.6727 75.0517 33.0279 74.7416C39.3831 74.4315 42.2578 78.158 42.2578 80.4033C42.2578 82.6486 31.6547 81.7844 29.2242 79.5921Z",
    fill: "#EDE0A9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7379 76.9879C58.3656 77.9693 55.3535 79.5944 50.7386 80.4678C46.1236 81.3412 44.9355 76.6562 44.8747 76.5044C44.8138 76.3526 51.3156 76.0648 54.7379 76.9879Z",
    fill: "#EDE0A9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0107 81.2622C71.2803 79.6521 68.1066 79.4545 65.2064 79.5481C62.3062 79.6416 62.3997 82.7486 63.2888 82.9501C64.1779 83.1516 70.9172 81.8215 71.0107 81.2622Z",
    fill: "#EDE0A9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.004 69.5769C103.215 71.5919 98.1902 75.694 90.3976 72.4555C82.605 69.2171 84.7568 67.3957 85.6924 66.8082C86.6279 66.2207 92.2399 64.7042 100.004 69.5769Z",
    fill: "#EDE0A9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2857 77.8831C41.2857 77.8831 42.1277 79.4062 40.9586 80.273C39.7895 81.1399 34.5511 81.3721 31.0431 79.9688C27.5351 78.5655 28.1586 76.5046 28.1586 76.5046C28.1586 76.5046 27.3015 77.4206 28.3071 79.4081C29.3126 81.3957 33.3846 82.1421 38.5281 81.8942C43.6717 81.6462 43.0181 80.1003 41.2857 77.8831Z",
    fill: "#CC81B3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5904 76.3396C26.5904 76.3396 27.3212 79.8627 21.4135 78.5032C15.5057 77.1437 15.5398 75.1908 15.8656 74.1735C15.8656 74.1735 14.8966 74.8598 15.0059 75.7384C15.1152 76.617 17.7955 78.9552 22.489 79.5329C27.1825 80.1106 27.6509 78.3069 26.5904 76.3396Z",
    fill: "#CC81B3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4187 74.049C27.5247 74.3107 27.3068 75.0886 26.3719 74.6993C25.437 74.3101 25.5986 73.6729 25.5986 73.6729C25.5986 73.6729 25.4024 73.7252 25.3821 74.0366C25.4737 74.3643 25.6602 74.6576 25.9182 74.8795C26.1762 75.1014 26.4941 75.242 26.8319 75.2836C27.7039 75.3928 27.804 74.5992 27.4187 74.049Z",
    fill: "#CC81B3"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.6256 71.2944C85.6256 72.873 83.8225 73.4919 82.2452 71.2944C80.6678 69.0968 85.6256 69.8858 85.6256 71.2944Z",
    fill: "#EDE0A9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4366 70.8249C85.6283 71.2953 85.2338 72.7032 83.5432 71.9993C81.8527 71.2953 82.1458 70.1445 82.1458 70.1445C82.1458 70.1445 81.7971 70.2394 81.7532 70.8027C81.7094 71.366 82.7954 72.8589 84.3734 73.0559C85.9514 73.2528 86.132 71.8181 85.4366 70.8249Z",
    fill: "#CC81B3"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.581 72.0787C141.581 73.6574 139.779 74.2763 138.201 72.0787C136.623 69.8811 141.581 70.6708 141.581 72.0787Z",
    fill: "#EDE0A9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.39 71.6099C141.581 72.0803 141.187 73.4882 139.497 72.7876C137.807 72.0869 138.1 70.9335 138.1 70.9335C138.1 70.9335 137.751 71.0277 137.707 71.591C137.663 72.1543 138.749 73.6472 140.324 73.8441C141.899 74.0411 142.086 72.6024 141.39 71.6099Z",
    fill: "#CC81B3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7786 69.1186C11.7786 69.1186 11.4201 71.5242 8.68406 71.1159C5.94806 70.7077 4.93073 69.3495 5.33439 67.924C5.08936 68.251 4.94994 68.6449 4.93474 69.0533C4.91954 69.4616 5.02929 69.8649 5.24934 70.2092C6.02918 71.4051 8.84761 72.1424 10.8103 71.534C12.773 70.9256 11.7786 69.1186 11.7786 69.1186Z",
    fill: "#CC81B3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5184 77.2509C55.5184 77.2509 56.3434 79.4308 51.8998 79.9685C50.6841 80.1657 49.4382 80.0487 48.2804 79.6287C47.1226 79.2087 46.0914 78.4996 45.2849 77.5688C45.2849 77.5688 45.5839 80.3729 49.6774 80.7674C53.7709 81.1619 56.5384 78.5188 56.4755 78.1295C56.4127 77.7402 55.5184 77.2509 55.5184 77.2509Z",
    fill: "#CC81B3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8399 80.5168C70.8399 80.5168 70.4774 81.6801 66.5802 82.3232C62.6829 82.9663 62.7568 82.0792 62.7568 82.0792C62.6871 82.303 62.7012 82.5446 62.7966 82.7588C62.8919 82.9729 63.062 83.1451 63.275 83.243C64.0391 83.5545 70.2851 82.0556 71.0283 81.6905C71.7715 81.3255 70.8399 80.5168 70.8399 80.5168Z",
    fill: "#CC81B3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.869 70.4977C100.869 70.4977 101.291 73.1395 94.8129 72.5311C88.3347 71.9226 85.5372 68.991 85.3187 68.1353C85.1001 67.2795 86.1731 66.5861 86.1731 66.5861C85.7705 66.6947 85.3999 66.8985 85.0925 67.1803C84.7851 67.4621 84.5499 67.8136 84.4067 68.2053C83.7047 69.6786 86.9104 72.5579 94.2764 73.8539C101.642 75.15 102.248 72.8379 100.869 70.4977Z",
    fill: "#CC81B3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0323 48.5294C13.0947 48.392 12.7218 53.2994 9.68553 57.2798C6.64924 61.2601 1.67249 61.7286 1.67249 61.7286C1.67249 61.7286 -3.16359 50.498 12.0323 48.5294Z",
    fill: "#FFDD81"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.726 65.532C151.984 68.2097 148.939 70.5589 145.653 72.5323C140.789 75.3075 133.071 74.7337 127.412 73.5228C122.142 72.3955 125.915 72.2797 116.748 71.4842C107.581 70.6886 103.652 70.5126 103.652 70.5126C103.652 70.5126 119.461 71.8643 124.318 73.4894C126.528 74.2293 132.781 77.4802 140.539 76.3026C148.296 75.125 151.312 71.7976 151.171 70.6592C151.031 69.5208 154.726 65.532 154.726 65.532Z",
    fill: "url(#paint10_linear_2_12365)"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.3213 29.6157C87.3213 30.6795 90.4158 31.1747 95.948 31.2075L116.485 31.4312C116.485 31.4312 119.78 26.9778 117.54 24.1987C115.373 21.5032 110.547 23.1087 110.242 23.2121C111.141 22.5526 119.892 21.4555 118.164 17.2991C116.431 13.1232 109.987 14.9917 109.987 14.9917C109.987 14.9917 117.85 6.60441 108.83 1.30774C108.294 0.989753 107.732 0.717922 107.15 0.495187H107.145C99.3454 -2.42858 96.1717 8.51215 98.5564 9.31881C98.9554 9.45601 99.3417 9.6274 99.7111 9.83108L99.721 9.835C101.161 10.6849 102.466 11.7461 103.592 12.9832C98.1986 8.57888 96.1848 18.444 96.1848 18.444C96.1848 18.444 93.4416 16.4918 90.5944 20.9772C89.7853 22.2439 89.3784 23.7259 89.4275 25.2282C89.4765 26.7304 89.9791 28.1827 90.8692 29.3939C90.8692 29.3939 88.3694 28.8051 87.5653 29.2428C87.4926 29.2742 87.4307 29.3263 87.3873 29.3926C87.3439 29.4589 87.321 29.5365 87.3213 29.6157Z",
    fill: "url(#paint11_linear_2_12365)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.3213 29.6158C87.3213 30.6795 90.4158 31.1748 95.948 31.2075L116.485 31.4313C116.485 31.4313 119.78 26.9779 117.54 24.1987C115.373 21.5033 110.547 23.1088 110.242 23.2121C111.141 22.5527 119.892 21.4555 118.164 17.2992C116.431 13.1232 109.987 14.9917 109.987 14.9917C109.987 14.9917 117.85 6.60446 108.83 1.3078C108.294 0.989806 107.732 0.717974 107.15 0.495239C107.585 0.730109 112.83 2.36896 111.95 7.53609C110.576 15.6185 100.146 9.97703 99.721 9.83506C101.161 10.685 102.466 11.7462 103.592 12.9832L103.597 12.9878C104.679 13.6027 105.615 14.4456 106.339 15.458C107.063 16.4704 107.558 17.6282 107.79 18.851C108.812 24.3754 100.565 22.571 100.565 22.571C100.565 22.571 103.243 23.3515 105.803 24.0293C109.576 25.027 112.14 28.8987 105.679 30.4722C99.8224 31.9043 88.9752 30.6737 87.5653 29.2428C87.4926 29.2743 87.4307 29.3264 87.3873 29.3926C87.3439 29.4589 87.321 29.5365 87.3213 29.6158Z",
    fill: "url(#paint12_linear_2_12365)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.855 29.1619C102.389 27.8534 99.3886 18.5869 94.8358 18.2467C90.283 17.9065 89.6536 25.8737 91.354 28.0987C93.0543 30.3238 100.607 29.3725 100.855 29.1619Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.162 22.4193C110.263 18.4991 105.189 12.927 101.517 12.1518C97.8445 11.3765 96.2089 16.2329 98.4346 19.8717C100.66 23.5105 106.162 22.4193 106.162 22.4193Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.463 9.41078C112.756 7.64435 111.265 0.658462 104.847 0.322841C98.4287 -0.0127797 97.2884 6.28878 99.8556 8.64598C102.423 11.0032 109.463 9.41078 109.463 9.41078Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.503 15.2153C117.477 16.2561 114.48 21.6922 110.223 21.8937C108.32 21.9833 108.236 17.1564 108.282 16.6886C108.329 16.2208 110.29 13.7413 114.503 15.2153Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0747 19.1638C98.4695 20.8327 97.1401 23.9685 94.0188 24.2184C90.8974 24.4683 91.9802 19.8841 93.093 18.8537C94.2059 17.8233 96.5369 18.522 97.0747 19.1638Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.2
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.832 13.1654C104.866 13.978 104.178 18.4595 100.249 19.0142C96.3208 19.569 98.1212 11.2825 102.832 13.1654Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.976 72.1072C146.976 72.1072 145.284 75.9331 137.892 76.2982C133.426 76.5068 128.981 75.5723 124.978 73.5831C128.341 74.4787 131.83 74.8033 135.301 74.5435C139.268 74.1517 143.182 73.3349 146.976 72.1072Z",
    fill: "url(#paint13_linear_2_12365)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.198 46.7616C149.781 51.1299 135.831 39.2779 132.837 29.4559C129.843 19.6339 129.958 18.0068 129.958 18.0068C129.958 18.0068 152.219 25.6208 150.198 46.7616Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.174 34.9542C106.174 34.9542 117.652 39.3081 127.381 39.4952C137.109 39.6823 143.6 34.9038 143.844 34.4452C144.639 32.9483 137.632 29.2218 132.082 28.4747C120.926 26.9739 106.174 34.9542 106.174 34.9542Z",
    fill: "#DB83A9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.914 57.1403C138.531 52.2441 110.193 48.5588 100.184 53.966C90.1738 59.3732 120.519 65.5714 131.914 57.1403Z",
    fill: "#A9B1D4"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.056 48.728C139.283 47.4424 140.036 38.7359 125.196 39.5491C110.355 40.3623 111.88 55.7714 135.056 48.728Z",
    fill: "#A9B1D4"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.949 30.3137C108.628 31.5352 108.75 33.5607 101.688 33.8937C94.6253 34.2267 93.0918 31.825 93.0918 31.825C93.0918 31.825 99.6636 29.195 103.949 30.3137Z",
    fill: "#DB83A9"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.983 33.43C138.316 32.4323 137.763 28.7084 136.983 26.9308C136.203 25.1533 126.569 21.5053 120.954 21.9731C115.339 22.4408 105.8 32.1693 105.145 33.9455C104.49 35.7217 117.21 37.2167 124.975 37.4999C132.74 37.7832 135.799 34.3191 136.983 33.43Z",
    fill: "url(#paint14_linear_2_12365)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.983 26.9307C136.435 26.298 129.001 30.7036 127.379 32.4498C125.757 34.1959 120.823 37.2675 120.823 37.2675C120.823 37.2675 125.593 37.8786 128.904 37.3002C132.214 36.7219 136.704 34.1599 137.577 32.93C138.451 31.7 136.983 26.9307 136.983 26.9307Z",
    fill: "#DB83A9"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.488 26.2138C135.629 27.2435 129.759 30.8909 121.804 31.6393C113.849 32.3878 109.919 30.641 109.732 30.5167C109.545 30.3924 114.596 22.6593 120.957 21.973C127.319 21.2867 135.347 25.2082 135.488 26.2138Z",
    fill: "#D96840"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.715 29.0164C131.715 29.0164 127.194 32.317 126.071 32.8508C124.948 33.3847 121.145 32.209 121.145 32.209L131.715 29.0164Z",
    fill: "#B2562B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.979 27.0133C133.61 27.7761 132.191 28.4454 130.732 29.0166C129.33 29.4562 123.012 31.2468 120.443 31.8252C117.874 32.4035 112.516 31.3417 112.516 31.3417C112.516 31.3417 118.409 32.6502 120.911 32.2092C123.413 31.7683 128.507 29.3378 131.058 29.7231C132.454 28.9562 133.768 28.0482 134.979 27.0133Z",
    fill: "#EA8E40"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.02 27.2579C129.179 28.0862 126.991 31.3273 119.973 30.3917C112.955 29.4562 127.039 26.5566 128.02 27.2579Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.96 29.2225C136.632 29.1623 133.96 33.9931 131.949 35.3029C129.937 36.6127 125.868 36.9817 125.868 36.9817C125.868 36.9817 127.739 29.3631 133.96 29.2225Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.309 27.8663C117.902 28.1359 114.83 29.4083 113.614 29.2219C112.398 29.0354 115.766 27.1643 117.309 27.8663Z",
    fill: "#9ADD00"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.839 31.825C104.267 31.1053 103.621 28.4583 98.8194 27.8662C97.5135 27.6316 96.1668 27.8763 95.0268 28.5551C93.8868 29.2339 93.03 30.3014 92.614 31.5613C92.614 31.7327 96.1377 33.0817 98.7258 33.1557C101.314 33.2296 103.527 32.3523 103.839 31.825Z",
    fill: "url(#paint15_linear_2_12365)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.839 31.825C103.944 31.4625 103.465 29.7733 102.436 29.545C101.407 29.3166 96.1922 30.9274 95.4673 31.4311C94.7424 31.9349 94.8785 32.8796 98.726 33.1557C102.574 33.4318 103.839 31.825 103.839 31.825Z",
    fill: "#DB83A9"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.112 28.9734C102.439 29.0519 98.6657 30.6089 96.8129 30.8595C95.6245 31.0371 94.4101 30.8806 93.3056 30.4074C93.2173 30.308 94.5702 28.2269 97.2192 27.8435C98.9305 27.664 100.653 28.0617 102.112 28.9734Z",
    fill: "#D96840"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.328 29.8323C99.4808 30.3107 98.5892 30.7051 97.6655 31.0099C97.0083 31.1744 96.3173 31.1426 95.678 30.9183C97.1771 30.3659 98.7389 30.0011 100.328 29.8323Z",
    fill: "#B2562B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.112 28.973C101.574 29.2425 101.017 29.4706 100.444 29.6554C99.1648 29.8118 97.8949 30.0367 96.6397 30.3292C95.8574 30.5524 95.0524 30.6867 94.24 30.7296C94.7402 30.8504 95.2524 30.9141 95.767 30.9194C96.6421 30.5606 97.5507 30.2897 98.4794 30.1107C99.6119 29.9145 100.405 29.8039 100.405 29.8039C101.026 29.65 101.608 29.3669 102.112 28.973Z",
    fill: "#EA8E40"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.016 35.7318C72.3689 34.7125 66.7765 41.894 62.7177 42.2231C58.6588 42.5522 58.7896 37.2974 67.016 35.7318Z",
    fill: "#A9B1D4"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3154 37.113C50.2735 36.8808 52.9513 41.9242 43.5206 42.2383C34.0898 42.5523 38.9926 37.321 44.3154 37.113Z",
    fill: "#FFDD81"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9577 66.7178C64.9885 64.5209 61.6643 62.8643 59.2888 65.7639C56.9133 68.6634 64.9139 69.9091 64.9577 66.7178Z",
    fill: "#D36F3B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7254 65.7083C64.7833 65.9975 64.7796 66.2956 64.7145 66.5833C64.6495 66.871 64.5246 67.1418 64.348 67.378C64.1713 67.6142 63.9469 67.8105 63.6893 67.9542C63.4318 68.0979 63.1468 68.1858 62.853 68.212C60.5462 68.6484 58.7314 67.3229 59.1239 65.9876C58.7411 66.3343 58.471 66.7878 58.3486 67.2895C58.1766 68.0844 60.032 69.5185 63.4464 69.2692C66.8608 69.02 65.2541 66.4207 64.7254 65.7083Z",
    fill: "#DB83A9"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5384 65.4602C61.3293 65.4602 61.2286 66.6686 59.977 66.5587C58.7255 66.4488 59.9535 65.4602 60.5384 65.4602Z",
    fill: "#E7792C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.908 37.0752C111.938 34.8783 108.614 33.2211 106.239 36.1214C103.863 39.0216 111.86 40.2626 111.908 37.0752Z",
    fill: "#D36F3B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.675 36.0651C111.733 36.3544 111.73 36.6529 111.665 36.9409C111.6 37.2289 111.475 37.5 111.299 37.7365C111.122 37.973 110.898 38.1696 110.64 38.3135C110.382 38.4574 110.097 38.5452 109.803 38.5714C107.495 39.0078 105.681 37.683 106.074 36.347C105.691 36.6937 105.42 37.1472 105.298 37.649C105.126 38.4438 106.982 39.8786 110.396 39.6287C113.811 39.3787 112.204 36.7775 111.675 36.0651Z",
    fill: "#DB83A9"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.487 35.817C108.279 35.817 108.178 37.0254 106.926 36.9161C105.674 36.8069 106.903 35.817 107.487 35.817Z",
    fill: "#E7792C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0125 31.6517C87.4188 32.1751 83.038 33.8931 81.4358 33.4678C79.8336 33.0426 82.7122 31.1551 85.0125 31.6517Z",
    fill: "#EABA13"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.846 46.9896C104.185 47.6975 102.65 50.1123 99.0281 49.6916C95.4063 49.2709 101.491 46.2732 102.846 46.9896Z",
    fill: "#EABA13"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3145 63.5218C23.6285 64.4011 21.0528 64.672 20.0486 64.2807C19.0443 63.8895 20.7591 63.3099 21.3145 63.5218Z",
    fill: "#EABA13"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8073 50.0159C41.3961 50.5249 40.0876 50.644 39.4838 50.1206C38.8799 49.5972 39.9202 49.2498 40.8073 50.0159Z",
    fill: "#EABA13"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6717 69.3009C32.8624 69.0641 27.1372 66.5473 24.9331 66.807C22.729 67.0667 28.1637 69.9977 31.6717 69.3009Z",
    fill: "#EABA13"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7875 62.5276C37.2497 62.9771 35.0862 63.5993 34.0099 63.2251C32.9337 62.8508 33.8235 61.9231 35.7875 62.5276Z",
    fill: "#EABA13"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.7596 49.9465C102.11 51.6024 97.4103 54.4522 92.9052 52.1526C88.4002 49.853 95.2932 49.0084 97.7596 49.9465Z",
    fill: "#EABA13"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.1185 69.3005C58.7367 69.9697 55.8286 70.9144 54.0491 69.8893C52.2696 68.8641 56.668 67.7316 58.1185 69.3005Z",
    fill: "#B0FF00"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.358 42.1198C113.976 42.7891 111.068 43.7338 109.289 42.7054C107.509 41.6769 111.908 40.551 113.358 42.1198Z",
    fill: "#B0FF00"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1228 66.5836C57.3988 66.9493 56.5745 67.8875 55.546 67.9575C54.5176 68.0275 53.3413 66.2977 55.1228 66.5836Z",
    fill: "#B0FF00"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0466 36.44C73.3227 36.8051 72.4983 37.7433 71.4699 37.8139C70.4414 37.8846 69.2651 36.1509 71.0466 36.44Z",
    fill: "#B0FF00"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.002 67.5042C55.0186 68.0348 53.6277 68.9377 52.2715 68.5242C50.9153 68.1107 52.0386 66.4804 54.002 67.5042Z",
    fill: "#B0FF00"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6145 68.0975C39.0927 69.1612 36.9311 69.3726 35.7149 68.297C34.4987 67.2214 38.1467 67.0566 38.6145 68.0975Z",
    fill: "#B0FF00"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1302 64.6954C41.1116 65.1534 39.4106 65.8966 39.0357 65.4602C38.6608 65.0239 39.1207 64.2277 40.1302 64.6954Z",
    fill: "#B0FF00"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.069 40.632C116.051 41.086 114.35 41.8331 113.974 41.3961C113.599 40.9591 114.059 40.1642 115.069 40.632Z",
    fill: "#B0FF00"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6614 59.972C66.2577 60.9043 63.0755 61.3282 62.3277 60.7669C61.5799 60.2055 62.7399 58.8526 64.6614 59.972Z",
    fill: "#B0FF00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.75 51.0579C149.071 51.5617 143.854 63.2227 127.097 62.6476C110.34 62.0726 127.419 50.3906 139.75 51.0579Z",
    fill: "#DB83A9"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.694 55.8241C138.725 53.9745 138.087 46.3855 131.057 44.6596C124.028 42.9337 118.383 51.9739 118.128 54.9749C117.873 57.9758 123.268 60.9938 125.71 61.5558C128.153 62.1178 135.086 60.5018 137.694 55.8241Z",
    fill: "url(#paint16_linear_2_12365)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.596 47.5838C135.854 49.6597 135.87 56.8084 129.945 58.8876C124.019 60.9667 118.749 55.9148 119.519 52.607C120.288 49.2992 129.401 43.7284 133.596 47.5838Z",
    fill: "#DB83A9"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.596 46.0808C134.539 47.3088 131.319 52.296 128.256 54.3693C125.194 56.4425 119.015 55.0235 118.612 54.7527C118.209 54.4818 123.031 45.5764 127.423 44.6775C131.814 43.7786 133.596 46.0808 133.596 46.0808Z",
    fill: "#FFA7FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.618 60.4077C132.903 60.6151 136.954 57.7071 137.576 55.0214C138.199 52.3358 135.496 47.136 135.189 46.8579C134.882 46.5799 129.844 53.7928 128.979 54.8677C128.114 55.9426 131.169 60.3351 131.618 60.4077Z",
    fill: "#FFA7FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.567 60.7389C130.996 60.47 129.373 56.6775 128.102 55.963C126.83 55.2486 119.158 55.6268 118.808 55.7262C118.457 55.8257 121.534 63.2361 130.567 60.7389Z",
    fill: "#DB83A9"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.877 51.968C131.061 51.8496 128.914 56.0347 128.67 56.1113C127.19 56.0014 125.718 55.8103 124.259 55.5388C124.125 55.4669 128.125 53.7345 130.877 51.968Z",
    fill: "#FFFFF0"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.389 55.4357C122.389 55.4357 120.661 55.6471 119.618 55.6556C118.574 55.6641 118.263 54.7625 118.35 54.6474C118.438 54.5322 120.144 55.2074 122.389 55.4357Z",
    fill: "#FFFFF0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.192 52.0435C132.223 50.3019 129.478 46.5323 125.351 47.4914C121.223 48.4505 120.697 52.5361 120.836 53.8819C120.976 55.2277 125.688 55.9048 130.192 52.0435Z",
    fill: "#FFB5E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.092 62.1755C125.745 62.2246 129.377 63.0457 129.432 64.1788C129.503 65.6744 124.829 67.2216 118.436 66.4431C112.043 65.6646 119.883 62.116 123.092 62.1755Z",
    fill: "#DB83A9"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.481 59.9437C125.162 62.5455 124.146 65.9561 120.669 66.3597C117.192 66.7634 112.913 63.256 111.51 60.7405C110.178 58.3552 114.45 53.6375 116.167 53.9457C117.883 54.2538 123.8 57.3444 124.481 59.9437Z",
    fill: "url(#paint17_linear_2_12365)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.968 55.0111C119.465 54.3863 122.69 58.332 122.715 62.6781C122.741 67.0241 114.031 66.3536 112.736 61.4396C111.44 56.5257 117.968 55.0111 117.968 55.0111Z",
    fill: "#DB83A9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.348 55.1785C118.623 54.9901 123.881 57.9492 124.27 59.9714C124.66 61.9936 123.571 64.3927 123.571 64.6249C123.571 64.8572 117.052 61.3904 116.976 61.115C116.901 60.8396 118.543 58.9711 118.348 55.1785Z",
    fill: "#FFA7FF"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.929 54.1652C117.827 54.2182 118.7 58.3425 116.929 60.7141C115.686 62.3772 112.022 61.9002 111.508 60.2561C111.075 58.8666 112.978 53.9317 116.929 54.1652Z",
    fill: "#FFA7FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.142 65.0764C123.343 64.8507 117.621 61.9924 116.971 61.9171C116.322 61.8419 113.19 62.447 111.509 60.7395C111.509 60.7395 114.216 65.376 118.829 65.8026C123.443 66.2292 123.142 65.0764 123.142 65.0764Z",
    fill: "#DB83A9"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.796 58.7217C117.796 58.7217 117.422 61.4413 117.414 61.7468C117.405 62.0524 115.553 61.5938 115.553 61.5938C115.553 61.5938 117.328 60.0668 117.796 58.7217Z",
    fill: "#FFFFF0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.785 60.3613C103.461 60.8193 103.686 63.938 98.0422 64.3057C92.3982 64.6734 95.2722 58.591 101.785 60.3613Z",
    fill: "#DB83A9"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.212 61.2079C102.675 60.2567 99.929 57.0764 97.1524 57.8334C94.3759 58.5903 93.4697 60.7342 94.9228 62.5399C96.3758 64.3456 100.709 64.2906 102.212 61.2079Z",
    fill: "url(#paint18_linear_2_12365)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.478 60.1931C101.729 60.9592 98.2567 63.0933 95.575 61.7561C92.8933 60.4188 96.665 58.0825 98.0428 58.0367C99.4206 57.9909 101.167 59.2405 101.478 60.1931Z",
    fill: "#DB83A9"
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.38 59.2742C101.72 59.9153 99.8543 61.2061 97.5593 61.3612C95.2643 61.5162 94.5446 60.3883 94.5021 60.0527C94.4595 59.7171 95.1478 57.7668 97.9636 57.7727C99.348 57.774 100.938 58.44 101.38 59.2742Z",
    fill: "#FFA7FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.0136 63.5409C99.238 63.6573 101.101 62.536 101.68 61.7856C102.258 61.0352 101.825 59.9897 101.614 60.0054C101.403 60.0211 99.6449 61.1961 98.2475 61.5102C98.2521 61.5095 97.8307 62.9266 99.0136 63.5409Z",
    fill: "#FFA7FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.2522 63.6162C98.5139 63.5789 97.912 61.7981 97.6916 61.6731C97.4711 61.5482 95.2624 61.4847 94.3628 60.3313C94.3602 60.3313 93.7479 63.3401 98.2522 63.6162Z",
    fill: "#DB83A9"
  }))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6736 61.2557C98.6736 61.2557 98.3354 61.8923 98.0992 61.9754C97.863 62.0585 96.6638 61.4383 96.6638 61.4383C97.3386 61.4575 98.0133 61.3962 98.6736 61.2557Z",
    fill: "#FFFFF0"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.3548 61.3755C95.9402 61.2026 95.5353 61.0074 95.1419 60.7906C94.9452 60.6695 94.7636 60.5254 94.6008 60.3615C94.7471 60.6953 94.9961 60.9736 95.3116 61.156C95.6271 61.3384 95.9926 61.4153 96.3548 61.3755Z",
    fill: "#FFFFF0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_12365",
    x1: 47.1258,
    y1: 86.2021,
    x2: 47.1258,
    y2: 6.2395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63902F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#84B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#99C407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1CC02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_12365",
    x1: 47.1264,
    y1: 86.2015,
    x2: 47.1264,
    y2: 49.8229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    stopColor: "#C46D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#DDAB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    stopColor: "#EFD88C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#FAF492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_12365",
    x1: 43.2861,
    y1: 74.7455,
    x2: 43.2861,
    y2: 9.68384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63902F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#84B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#99C407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1CC02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_12365",
    x1: 42.8171,
    y1: 76.2986,
    x2: 42.8171,
    y2: 41.0093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E765E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#938068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#A8AD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#B5C9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_12365",
    x1: 73.2432,
    y1: 41.302,
    x2: 73.2432,
    y2: 32.9213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E765E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#938068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#A8AD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#B5C9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_12365",
    x1: 45.0083,
    y1: 76.5042,
    x2: 125.944,
    y2: 76.5042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    stopColor: "#C46D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#DDAB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    stopColor: "#EFD88C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#FAF492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_12365",
    x1: -32.3051,
    y1: 72.2844,
    x2: 23.586,
    y2: 72.2844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    stopColor: "#C46D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#DDAB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    stopColor: "#EFD88C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#FAF492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_12365",
    x1: 92.0009,
    y1: 50.9877,
    x2: 109.898,
    y2: 50.9877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E765E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#938068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#A8AD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#B5C9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_12365",
    x1: 27.3531,
    y1: 23.1398,
    x2: 71.2382,
    y2: 23.1398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E765E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#938068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#A8AD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#B5C9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_12365",
    x1: 4.2888,
    y1: 15.914,
    x2: 24.7583,
    y2: 15.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E765E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#938068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#A8AD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#B5C9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_12365",
    x1: -2.42824,
    y1: 76.557,
    x2: -2.42824,
    y2: 65.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF7A70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.059,
    stopColor: "#E1806E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#F1AD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FBC95C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD45A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_12365",
    x1: 8.43911,
    y1: 24.0448,
    x2: 8.43911,
    y2: -8.07797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#408700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#4A8200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#607A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_12365",
    x1: 8.43911,
    y1: 24.0375,
    x2: 8.43911,
    y2: -7.42438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE9D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#C8BD6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#E0D9AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#F0EDD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FBFAF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_12365",
    x1: -9.20488,
    y1: 76.3268,
    x2: -9.20488,
    y2: 72.1072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    stopColor: "#C46D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#DDAB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    stopColor: "#EFD88C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#FAF492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_12365",
    x1: 5.28906,
    y1: 37.5164,
    x2: 5.28906,
    y2: 21.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A93D54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#AB4449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#B3592D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8661D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2_12365",
    x1: 28.4773,
    y1: 33.1601,
    x2: 28.4773,
    y2: 27.7794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A93D54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#AB4449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#B3592D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8661D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2_12365",
    x1: -0.287069,
    y1: 62.076,
    x2: -2.65769,
    y2: 39.5535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#FF9171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#FF5364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#FF265B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#FF0A56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2_12365",
    x1: 9.58933,
    y1: 66.2546,
    x2: 7.73429,
    y2: 51.0794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#FF9171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#FF5364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#FF265B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#FF0A56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2_12365",
    x1: 28.9496,
    y1: 63.895,
    x2: 28.3267,
    y2: 56.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#FF9171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#FF5364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#FF265B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#FF0A56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0054"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamelevel2);
export default __webpack_public_path__ + "static/media/gamelevel2.e9324af0c866ea0e51179dd81f18d9df.svg";
export { ForwardRef as ReactComponent };